import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormControl, FormsModule, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-nia-input',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NiaInput),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => NiaInput),
      multi: true
    }
  ],
  templateUrl: './nia-input.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule
  ]
})
export class NiaInput implements ControlValueAccessor {

  @Input()
  public readonly: boolean = false;

  public internalValue: string = '';

  onChange: (_: string) => void = (_: string) => { };

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void { }

  writeValue(val: string): void {
    this.internalValue = val;
  }

  updateChanges(value: string) {
    this.internalValue = value;
    this.onChange(value);
  }

  validate({ value }: FormControl) {
    if (value) {
      console.log('value on validation', value)
      if (!this.isValid(value)) {
        return { format: true };
      }
    }
    return null;
  }


  public isValid(value: string): boolean {
    value = value.toUpperCase().replace(/-/g, '');

    if (value.length !== 7) {
      return false;
    }

    const numberPart = value.substring(0, 6);
    if (!/^\d{6}$/.test(numberPart)) {
      return false;
    }

    const controlLetter = value.charAt(6);
    if (!/^[A-Z]$/.test(controlLetter)) {
      return false;
    }

    return true;
  }
}
